/* eslint-disable import/prefer-default-export */
import { types, isAlive } from 'mobx-state-tree';

import { listRequestsForStudy, requestPublish } from '../../helpers/api';
import { BaseStore } from '../BaseStore';
import { StudyPublishRequest } from './StudyPublishRequest';

const StudyPublishRequestsStore = BaseStore.named('StudyPublishRequestsStore')
  .props({
    studyId: types.identifier,
    requests: types.array(StudyPublishRequest),
    tickPeriod: 300 * 1000, // 5 minutes
  })

  .actions(self => {
    // save the base implementation of cleanup
    const superCleanup = self.cleanup;

    return {
      doLoad: async () => {
        const newRequests = await listRequestsForStudy(self.studyId);
	if (isAlive(self)) {      
            self.runInAction(() => {
               self.requests = newRequests || [];
            });
	} else {
            console.warn("MST: Load finished, but StudyPublishRequestsStore was removed. Aborting update.");
	}
      },

      requestPublish: async study => {
        await requestPublish(study);
        await self.load();
      },

      cleanup: () => {
        superCleanup();
      },
    };
  })
  .views(self => ({
    hasOngoing() {
      return self.requests.some(request => {
        if (request.isOngoing()) {
          return true;
        }
        return false;
      });
    },

    hasSuccessful() {
      return self.requests.some(request => {
        if (request.isSuccessful()) {
          return true;
        }
        return false;
      });
    },
  }));

export { StudyPublishRequestsStore };
